import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { UiState } from 'src/app/store/ui';
import * as fromStore from '../../../../store/ui';
import * as fromAuth from '../../../../store/auth';
import { AuthState } from 'src/app/store/auth';
import { Router } from '@angular/router';
import { take, withLatestFrom, map, filter } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { FeedbackDialogComponent } from '../../feedback-dialog/feedback-dialog.component';
import { TrackingService } from 'src/app/modules/shared/services/tracking.service';
import * as fromEvents from '../../tracking/events';
import { MatDialog } from '@angular/material/dialog';
import { FeatureService } from '../../services/feature.service';

@Component({
    selector: 'app-location-sidebar',
    templateUrl: './location-sidebar.component.html',
    styleUrls: ['./location-sidebar.component.scss'],
    standalone: false
})
export class LocationSidebarComponent implements OnInit {
  selectedLocationId$ = this.store.select(fromStore.selectSelectedLocationId);
  cctvEnabled$ = this.feature.featureEnabled('app.cctv-events');
  staffingEnabled$ = this.feature.featureEnabled('app.staffing-metrics');

  locations$ = this.store.select(fromAuth.selectAvailableLocations);
  linkLocationId$ = combineLatest([this.selectedLocationId$, this.locations$]).pipe(
    map(([locationId, locations]) => locationId ?? locations[0]?.id),
  );
  selectedLocation$ = this.linkLocationId$.pipe(
    withLatestFrom(this.locations$),
    map(([locationId, locations]) => {
      return locations.find(loc => loc.id === locationId);
    }),
  );
  isTheOne$ = this.selectedLocation$.pipe(
    filter(loc => !!loc),
    map(loc => loc.customerId === 1078),
  );

  isSubwayCustomer$ = this.store.select(fromStore.selectIsSubwayCustomer);

  constructor(
    private store: Store<{ ui: UiState; auth: AuthState }>,
    private router: Router,
    private dialog: MatDialog,
    private tracking: TrackingService,
    private feature: FeatureService,
  ) {}

  ngOnInit(): void {
    this.selectedLocationId$.pipe(take(1), withLatestFrom(this.locations$)).subscribe(([locationId, locations]) => {
      if (locationId === null && this.router.url.startsWith('/locations')) {
        this.router.navigate([], {
          queryParams: {
            locationId: locations[0].id,
          },
          queryParamsHandling: 'merge',
        });
      }
    });
  }

  closeSidebar(
    clickedItem:
      | 'daily-reports'
      | 'location-report'
      | 'employee-analytics'
      | 'sales-analytics'
      | 'employee-management'
      | 'feedback'
      | 'cctv'
      | 'staffing-analytics'
      | 'onboarding',
  ) {
    this.store.dispatch(fromStore.closeSidebar());
    this.tracking.track(fromEvents.sidebarClicked({ item: clickedItem }));
  }

  openFeedbackDialog() {
    FeedbackDialogComponent.open(this.dialog);
    this.closeSidebar('feedback');
  }

  showOnboarding() {
    this.store.dispatch(fromAuth.loadFeatures({for: 'All'}));
  }

}
